import { useTranslation } from 'react-i18next'
import Modal from '~/components/Modal'
import TokenListItem, { Token } from './TokenListItem'
import styled from 'styled-components'

interface TokenlistModalProps {
  tokens: Token[]
  isOpen: boolean
  onDismiss: () => void
  onSelect: (token: BaseTokenlonToken) => void
}

const TokenlistModal: React.FC<TokenlistModalProps> = ({
  tokens,
  isOpen,
  onDismiss,
  onSelect,
}) => {
  const { t } = useTranslation()

  return (
    <Modal
      title={t('select_token')}
      isOpen={isOpen}
      onDismiss={onDismiss}
      animate={false}
      headerStyle={{
        marginBottom: '0',
      }}
    >
      <div>
        {tokens.map((token) => (
          <TokenListItem
            key={`${token.address}`}
            token={token}
            onSelect={onSelect}
          ></TokenListItem>
        ))}
      </div>
    </Modal>
  )
}

export default TokenlistModal
